import { dropdownValuesService } from "services";

const loadMerchantStatuses = async (search, prevOptions, { page }) => {
	try {
		const merchantStatuses = await dropdownValuesService.getMerchantStatuses();

		return {
			options: merchantStatuses?.filter(
				status => status.name !== "Other",
			),
			hasMore: false,
			additional: {
				page: page + 1,
			},
		};
	} catch {
		return { options: [] };
	}
};

const merchantStatusColumn = () => ({
	name: "merchantStatus",
	type: "select" as const,
	loadOptions: loadMerchantStatuses,
	getOptionLabel: option => option.name,
	getOptionValue: option => option.id,
	placeholder: "Merchant Status",
});

export default merchantStatusColumn;
